import * as React from "react"

function TrippleSvgComponent(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={14}
      height={9}
      viewBox="0 0 14 9"
      {...props}
    >
      <g data-name="Group 2189" transform="translate(.254)" fill="#b5b5c3">
        <rect
          data-name="Rectangle 2206"
          width={14}
          height={3}
          rx={1}
          transform="translate(-.253)"
        />
        <rect
          data-name="Rectangle 2207"
          width={14}
          height={3}
          rx={1}
          transform="translate(-.253 6)"
        />
      </g>
    </svg>
  )
}

export default TrippleSvgComponent
